import { Instance } from 'mobx-state-tree'
import { ReferringParamsModelBase } from './ReferringParamsModel.base'

/* The TypeScript type of an instance of ReferringParamsModel */
export interface ReferringParamsModelType extends Instance<typeof ReferringParamsModel.Type> {}

/* A graphql query fragment builders for ReferringParamsModel */
export {
  selectFromReferringParams,
  referringParamsModelPrimitives,
  ReferringParamsModelSelector
} from './ReferringParamsModel.base'

/**
 * ReferringParamsModel
 */
export const ReferringParamsModel = ReferringParamsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
